import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { configureStore } from "@reduxjs/toolkit";
import { Provider } from "react-redux"
import cartReducer, { getTotals } from "./features/slices/cartSlice"
import authReducer from "./features/slices/authSlice"
import favoriteReducer from "./features/slices/favoriteSlice"
import themeReducer from "./features/slices/themeSlice"
import { authApi } from './features/authApi';
import { fullApi } from './features/fullApi';
import TagManager from 'react-gtm-module';
import { CookiesProvider } from "react-cookie";

//^INITIALIZE GTM 
const tagManagerArgs = {
  gtmId: 	'GTM-W76BNWD'
}
TagManager.initialize(tagManagerArgs)

const store = configureStore({
  reducer: {
    cart: cartReducer,
    auth: authReducer,
    favorite: favoriteReducer,
    theme: themeReducer,
    [fullApi.reducerPath]: fullApi.reducer,
    [authApi.reducerPath]: authApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat([
      authApi.middleware,
      fullApi.middleware,
    ]
  ),
});

store.dispatch(getTotals())

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <CookiesProvider>
      <App />
    </CookiesProvider>
      
  </Provider>
);

